import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';

import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import estadoMock from '../../../common/mock/estadoMock';

import existenciaService from '../../../service/administracion/existenciaService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingSource: true,
            loadingExcel: false,
            loadingPdf: false,
            loadingPrint: false,
            estados: estadoMock.values,
            existencias: [],
            catalogos: [],
            filter: {
                nombre: '',
                codigoSunat: '',
                estado: 0,
                tipo: 1,
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            formValues: this.fetchEmptyFormValues()
        }
    }

    /********* PAGINATION ********/

    handleClearFilters = () => {
        var filter = {
            nombre: '',
            codigoSunat: '',
            estado: 0,
            tipo: 1,
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };


    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await existenciaService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Existencia.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await existenciaService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Existencia.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await existenciaService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    handleDeleteActive = (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.flag)
                response = await existenciaService.eliminar(values);
            else
                response = await existenciaService.activar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    handleChangeTab = async (key) => {
        this.setState({
            formValues: {
                ...this.state.formValues,
                activeKey: key,
            },
            filter: {
                ...this.state.filter,
                page:1,
                activeKey: key,
                tipo: parseInt(key),
            },
        });
        setTimeout(async () => {
            this._handlePagination(this.state.filter);

        }, 100);
    };

    /******************** FORM MODAL *****************/

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            nombre: '',
            codigoSunat: '',
            activeKey: "1",
            existencias: [],
            catalogos: []
        };
    };



    handleNew = () => {
        var formValues = this.fetchEmptyFormValues();
        formValues.existencias = this.state.existencias;
        formValues.catalogos = this.state.catalogos;

        formValues.activeKey = this.state.formValues.activeKey;
        this.setState({ visible: true, formValues });
    };


    handleEdit = async (values) => {
        const response = await existenciaService.obtenerPorId(values.id);
        if (response !== undefined) {
            this.setState({
                visible: true,
                formValues: {
                    id: response.id,
                    nombre: response.nombre,
                    codigoSunat: response.codigoSunat,
                    existencias: this.state.existencias,
                    activeKey: this.state.formValues.activeKey

                }
            });
        }
    };

    handleSave = (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.id === 0)
                response = await existenciaService.registrar(values);
            else
                response = await existenciaService.modificar(values);

            if (response.status === 200) {
                form.resetFields();
                this.setState({ visible: false });
                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    async componentDidMount() {
        this._initPagination(this.state.filter, existenciaService.paginacion);
        const existencias = await existenciaService.listarSunat(0);

        this.setState({
            loadingSource: false,
            existencias: existencias ? existencias.filter(e => e.tipoExistencia == 1) : [],
            catalogos: existencias ? existencias.filter(e => e.tipoExistencia == 2) : []

        });
    }

    render() {
        return (
            <div>
                <Header
                    title={this.state.formValues.activeKey == "1" ? "Tipo de Existencia" : "Cátalogo de Existencia"}
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    estados={this.state.estados}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPrint={this.state.loadingPrint}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onPrint={this.handlePrint}
                    onEdit={this.handleEdit}
                    onDeleteActive={this.handleDeleteActive}
                    onChangeTab={this.handleChangeTab}
                    formValues={this.state.formValues}
                    onChange={this._handleChangePagination}

                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                />
            </div>
        );
    };
}